/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect, useMemo } from "react";
import useSelect from "~components/Form/hooks/useSelect";
import { db } from "~/db/db";
import prepareForOptions from "~services/utils/prepareForOptions";
import useUsuario from "./useUsuario";
import { getColumnIntoKey } from "~pages/PriceSearchV2/utils/initializerHelpers";

const useGrupoSegmento = ({
  formikRef,
  trilha = 0,
  grupoSegmentoDisponiveis,
  permitir = 0,
  salvarLocalStorage,
  chave,
}) => {
  const [grupoSegmento, setGrupoSegmento] = useState(0);
  const grupoSegmentoSelect = useSelect("grupoSegmento");
  const [onGrupoSegmento, setOnGrupoSegmento] = useState(false);
  const [fila, setFila] = useState(null);
  const [grupoSegmentoObjeto, setGrupoSegmentoObjeto] = useState({});

  const { usuario } = useUsuario();
  const isCarteiraRecebedor = /\/carteira\/recebedor\/\d+/.test(window.location.pathname);

  const [gruposSegmentos, setGruposSegmentos] = useState([]);

  const distribuidor = useMemo(
    () => usuario?.slugAcessos.includes("acesso-ao-grupo-de-segmento-distribuidor"),
    [usuario]
  );
  const exportador = useMemo(() => usuario?.slugAcessos.includes("acesso-ao-grupo-de-segmento-exportador"), [usuario]);

  const fetchGruposSegmentos = async (signal) => {
    let query = db.grupoSegmento;
    const result = [];

    await query
      .filter((item) => {
        if (signal.aborted) return false;

        if (item.id === permitir) return true;

        return (
          item.ativo &&
          (!trilha || item.trilhaId === trilha) &&
          (!grupoSegmentoDisponiveis || grupoSegmentoDisponiveis.includes(item.id)) &&
          (distribuidor || !["400", "486"].includes(item.codigo)) &&
          (exportador || item.codigo !== "411")
        );
      })
      .each((item) => result.push(item));

    if (!signal.aborted) {
      setGruposSegmentos(result);
    }
  };

  useEffect(() => {
    const controller = new AbortController();
    const { signal } = controller;

    fetchGruposSegmentos(signal);

    return () => controller.abort(); // Cancela a chamada anterior quando uma nova começa, pois uma estava afetando a outra
  }, [trilha, distribuidor, exportador, grupoSegmentoDisponiveis, isCarteiraRecebedor, permitir]);

  useEffect(() => {
    if (trilha !== 0 && !isCarteiraRecebedor) {
      const exists = (gruposSegmentos || []).find((e) => e.trilhaId === trilha || e.id == permitir);

      if (!exists) {
        onChangeGrupoSegmento({
          value: null,
        });
      }
    }
  }, [trilha, gruposSegmentos, isCarteiraRecebedor]);

  const optionsGrupoSegmento = useMemo(
    () =>
      prepareForOptions(
        (gruposSegmentos || []).sort((a, b) => a.nome.localeCompare(b.nome)),
        ["nome"],
        "id"
      ),
    [gruposSegmentos]
  );

  function onChangeGrupoSegmento(e) {
    setOnGrupoSegmento(e.value > 0);
    grupoSegmentoSelect.upDateValue(e.value);
    grupoSegmentoSelect.upDateDefaultValue(e || "");
    if (e && e.value && salvarLocalStorage) {
      localStorage.setItem(chave, JSON.stringify(e));
    }
    formikRef?.current?.setFieldValue("grupoSegmentoId", e.value);
    setTimeout(() => formikRef?.current?.setFieldTouched("grupoSegmentoId", true));
    setGrupoSegmento(e.value);
  }

  function SetSelectGrupoSegmento(id, setGrupoSegmentosInitialized = undefined) {
    if (optionsGrupoSegmento?.length > 0) {
      const grupo = optionsGrupoSegmento.find((item) => item.value === id);
      if (grupo) {
        onChangeGrupoSegmento(grupo);
        if (setGrupoSegmentosInitialized !== undefined) setGrupoSegmentosInitialized(true);
      }
      setFila(null);
    } else {
      setFila(id);
    }
  }

  useEffect(() => {
    if (fila && optionsGrupoSegmento?.length > 0) {
      SetSelectGrupoSegmento(fila);
    }

    if (gruposSegmentos?.length > 0) {
      setGrupoSegmentoObjeto(getColumnIntoKey({ data: gruposSegmentos, prefix: "id-" }));
    }
  }, [fila, optionsGrupoSegmento, gruposSegmentos]);

  function CleanForFilter(option) {
    onChangeGrupoSegmento(option);
    if (!option || !option.value) {
      localStorage.removeItem(chave);
    }
  }

  useEffect(() => {
    if (salvarLocalStorage) {
      const cidade = localStorage.getItem(chave);

      if (cidade) {
        const filialObj = JSON.parse(cidade);
        onChangeGrupoSegmento(filialObj);
        setGrupoSegmento(filialObj.value);
      }
    }
  }, []);

  return {
    optionsGrupoSegmento,
    gruposSegmentos,
    grupoSegmento,
    grupoSegmentoSelect,
    onChangeGrupoSegmento,
    SetSelectGrupoSegmento,
    onGrupoSegmento,
    grupoSegmentoObjeto,
    CleanForFilter,
  };
};

export default useGrupoSegmento;
